import { render, staticRenderFns } from "./CardCanvan.vue?vue&type=template&id=103385a8&scoped=true"
import script from "./CardCanvan.vue?vue&type=script&lang=js"
export * from "./CardCanvan.vue?vue&type=script&lang=js"
import style0 from "./CardCanvan.vue?vue&type=style&index=0&id=103385a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103385a8",
  null
  
)

export default component.exports